import { PreParsedEvent } from "./AppContext";
import { ClinicsEnum } from "./common/enums";

export const is_template_time =  (e: PreParsedEvent) => e.subject?.startsWith("Schedule ");
export const is_rounds = (e: PreParsedEvent) => e.subject?.startsWith("BMP-ROUNDS");
export const is_appointment = (e: PreParsedEvent) => e.subject?.includes("DDS APPT"); // not sure if this covers appts made in specialty clinic

export const is_specialty_clinic_appt = (e: PreParsedEvent) => e.bodyPreview?.includes("Changes to this appointment must be made in") && !(e.subject?.includes("DDS APPT"))
export const is_epic_event = (e: PreParsedEvent) => (
  is_template_time(e) || 
  is_rounds(e) || 
  is_appointment(e) || 
  e.subject?.startsWith("BMP") ||
  e.bodyPreview?.includes("Changes to this appointment must be made in") || //covers all specialty clinics?
  e.subject?.includes("PROVIDER REQUEST") ||
  e.subject?.includes("UNA - TEACHING") || 
  e.subject===("Holiday")
  
)


export const is_hygiene_check = (e: PreParsedEvent) => e.subject?.includes("HYGIENE CHECK");



export const is_specialty_clinic_template = (e: PreParsedEvent) => {return  is_template_time(e) && !(e.clinicName === undefined || e.clinicName === ClinicsEnum.HOME)}

export const generateTemplateTimeforDay = (day : Date): PreParsedEvent[]  => {

  let nine = new Date(day);
  let noon = new Date(day);
  let onethirty = new Date(day);
  let five = new Date(day);
  nine.setHours(9,0,0,0);
  noon.setHours(12,0,0,0);
  onethirty.setHours(13,30,0,0);
  five.setHours(17,0,0,0);
return [{
  startDateUTCMilliseconds: nine.getTime(),
  endDateUTCMilliseconds: noon.getTime(),
  subject: "Schedule " //space is required
  },{
  startDateUTCMilliseconds: onethirty.getTime(),
  endDateUTCMilliseconds: five.getTime(),
  subject: "Schedule "
  },]
}

export const generateAppointmentFromTo = (start: Date, end: Date) : PreParsedEvent[] => {
  return[{
    startDateUTCMilliseconds: start.getTime(),
    endDateUTCMilliseconds: end.getTime(),
    subject: "34 DDS APPT"
  }]
 }




export interface EventFilter {
    (source: PreParsedEvent[], event?: PreParsedEvent, callback?: CallableFunction): PreParsedEvent[];
  }

// type FilterType = {
//     lalsal: EventFilters().getOwnPropertyNames(obj).filter(item => typeof obj[item] === 'function')
// }
export class EventFilters {
  events: PreParsedEvent[];
  
//   selectedFilters?: eventFilterFunctions[];
  constructor(
    events: PreParsedEvent[],
    // selectedFilters: eventFilterFunctions[] | undefined
  ) {
    this.events = events;
    // this.selectedFilters = selectedFilters;
  }

  Epic() {
      this.events = this.events.filter((e) => is_epic_event(e));
    return this
  }
  Rounds() {
      this.events = this.events.filter((e) => is_rounds(e));
    return this
  }
  Appts() {
    this.events = this.events.filter((e) => is_appointment(e));
    return this
  }

  Free(){
    this.events = []
    return this
  }
}
